import { Injectable } from '@angular/core';
import { UserAccountService } from './user-account.service';
import { Router } from '@angular/router';
import { signOut } from 'aws-amplify/auth';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(
    private _userAccountService: UserAccountService,
    private _router: Router,
    private _languageService: LanguageService
  ) {}

  public async logoutWithAmplify(): Promise<void> {
    await signOut({ global: true });
    this.clearCognitoStorage();
    this._userAccountService.resetUserData();

    const currentLang = this._languageService.getCurrentLanguageCode();
    this._router.navigateByUrl(`${currentLang}/no-tenant-fallback`).then(() => {
      window.location.reload();
    });
  }

  private clearCognitoStorage(): void {
    Object.keys(localStorage).forEach((key) => {
      if (key.includes('CognitoIdentityServiceProvider')) {
        localStorage.removeItem(key);
      }
    });
  }

  public loginWithAmplify(): void {
    const currentLang = this._languageService.getCurrentLanguageCode();
    this._router.navigateByUrl(`${currentLang}/login`);
  }
}
